import styled, { css } from 'styled-components';

export const Logo = styled.i`
  font-style: normal;
  display: flex;
  align-items: center;
  ${({ cursor }) =>
    css`
      cursor: ${cursor};
    `}
`;
